/*
  Copyright (C) 2026 Sber

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

          http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.

  Maintainers:
      Konstantin Myachin <kvmyachin@gmail.com>, Sber

  Contributors:
      Konstantin Myachin <kvmyachin@gmail.com>, Sber - 2026
*/

// Раскрытие разделов общего дерева (Controls/Tree.vue): разделы, помеченные в данных флагом expand.

export interface TreeExpandNode {
  key: string;
  expand?: boolean;
  items?: TreeExpandNode[];
}

// Ключи всех разделов с флагом expand, на любой глубине
export const expandedTreeKeys = (items: TreeExpandNode[] | null | undefined): string[] => {
  const keys: string[] = [];
  const walk = (nodes: TreeExpandNode[] | null | undefined) => (nodes || []).forEach((node) => {
    if (node.expand) keys.push(node.key);
    walk(node.items);
  });
  walk(items);
  return keys;
};
